exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Group-module__wrapper___2w3Ke{background-color:#bdccd4;padding:.15em .2em;border-radius:4px;display:grid;gap:.25em;justify-content:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Group-module__wrapper___2w3Ke"
};